import { useConfig } from '@/composables';
import { configure } from 'vue-gtag';
import { Router } from 'vue-router';

export const initGa = (router: Router) => {
  const { gaTagId } = useConfig().value;

  if (gaTagId) {
    configure({
      tagId: gaTagId,
      pageTracker: {
        router,
      },
    });
  }
};
